import axios from 'axios';

// Función para realizar la solicitud GET a la API
export const validarCodigoCorreo = async (hashedIdLicencia, correo, codigoValidacionCorreo) => {
    try {
        console.log("validarCodigoCorreo", validarCodigoCorreo)
        const response = await axios.get(`${process.env.REACT_APP_SERVER_BACKEND}/v1/registrar/${hashedIdLicencia}/correo/${correo}/enviar-codigo-validacion/${codigoValidacionCorreo}`);

        if (response.status === 200) {
            console.log("response.data", response)
            return response;
        } else {
            throw new Error(`Error en la solicitud. Código de estado: ${response.status}`);
        }


    } catch (error) {
        console.error('Error al obtener los datos:', error);
        throw new Error('Error al obtener los datos ' + error);
    }
};
